import React, { useEffect, useState } from "react";
import Lottie from "lottie-react";
import celebrationAnim from "../assets/easter/karma-celebration.json";

function EasterEgg() {
  const [show, setShow] = useState(false);
  const [input, setInput] = useState("");

  useEffect(() => {
    const handleKeyDown = (e) => {
      const newInput = (input + e.key.toLowerCase()).slice(-5);
      setInput(newInput);

      if (newInput === "karma") {
        setShow(true);
        setTimeout(() => setShow(false), 6000); // hide after 6s
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [input]);

  if (!show) return null;

  return (
    <div className="fixed inset-0 flex justify-center items-center z-[9999] bg-black bg-opacity-70">
      <Lottie animationData={celebrationAnim} className="w-96" loop={false} />
      <p className="absolute bottom-12 text-white text-2xl font-bold animate-pulse">
        🎉 KD Mode Activated!
      </p>
    </div>
  );
}

export default EasterEgg;
